module.exports = __webpack_public_path__ + "static/img/supreme-court.061c536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/supreme-court.png
// module id = I4no
// module chunks = 0